import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "popover-content-box" }
const _hoisted_2 = { class: "pages-item-index" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "pages-item-hover-mask" }
const _hoisted_5 = { class: "pages-item-content" }

import { EditPen, VideoPlay, Loading, View } from "@element-plus/icons-vue";
import { PDF_PAGE_STATUS } from "@/request/appCenter";
import { ref, watch } from "vue";



export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  element: {
    type: Object,
    default: () => ({})
  },
  activeItem: {
    type: Object,
    default: () => ({})
  },
  index: {
    type: Number,
    default: 0
  },
  alwaysEnable: {
    type: Boolean,
    default: false
  }
},
  emits: ['imageClick', "queueLoadVideo", "checkboxClick"],
  setup(__props, { emit: __emit }) {

const props = __props

const emits = __emit

const handleImageClick = (item: any) => {
  if (!props.alwaysEnable && item.status !== PDF_PAGE_STATUS.SUCCESS) return
  item.checked = !item.checked
  emits('checkboxClick', item)
}

const postUrl = ref("")
const loadingVideoPost = ref(false)

const loadVideoPost = async () => {
  loadingVideoPost.value = true
  try {
    if (!props.element.videoUrl) {
      loadingVideoPost.value = false
      return
    }
    const url = props.element.videoUrl
    // 加载视频数据
    const videoData = await new Promise<HTMLVideoElement>((resolve, reject) => {
      const video = document.createElement('video');
      video.src = url;
      video.preload = 'metadata';
      video.crossOrigin = 'anonymous'; // 允许跨域
      video.muted = true;
      video.playsInline = true;
      video.onloadedmetadata = () => resolve(video);
      video.onerror = (e) => reject(e);
    });

    if (!videoData) {
      loadingVideoPost.value = false
      return
    }

    postUrl.value = await new Promise<string>((resolve) => {
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');

      canvas.width = videoData.videoWidth;
      canvas.height = videoData.videoHeight;

      videoData.currentTime = 0; // Seek to the first frame
      videoData.onseeked = () => {
        context?.drawImage(videoData, 0, 0, canvas.width, canvas.height);
        const imageUrl = canvas.toDataURL();
        resolve(imageUrl);
      };
    })
  } catch (error) {
    console.error(error)
  } finally {
    loadingVideoPost.value = false
  }
}

watch(
  () => props.element.videoUrl,
  () => loadVideoPost()
)

if (props.element.videoUrl) {
  loadingVideoPost.value = true
  emits("queueLoadVideo", loadVideoPost)
}

return (_ctx: any,_cache: any) => {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['pages-item', { 'editing': __props.activeItem?.id === __props.element.id, 'error': !__props.element.content || __props.element.status === _unref(PDF_PAGE_STATUS).FAILED, 'checked': __props.element.checked }]),
    onClick: _cache[7] || (_cache[7] = ($event: any) => (handleImageClick(__props.element)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, "P" + _toDisplayString(__props.index), 1),
      _createElementVNode("img", {
        class: "pages-item-image",
        src: postUrl.value || __props.element.imageUrl
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        (__props.element.status === _unref(PDF_PAGE_STATUS).DRAFT)
          ? (_openBlock(), _createBlock(_unref(EditPen), {
              key: 0,
              class: "pages-item-hover-mask-icon",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emits('imageClick', __props.element)), ["stop"]))
            }))
          : (_openBlock(), _createBlock(_unref(View), {
              key: 1,
              class: "pages-item-hover-mask-icon",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (emits('imageClick', __props.element)), ["stop"]))
            }))
      ])
    ]),
    (__props.activeItem?.id !== __props.element.id)
      ? (_openBlock(), _createBlock(_component_el_popover, {
          key: 0,
          placement: "top",
          width: 200,
          trigger: "hover",
          "hide-after": 0,
          "show-after": 100,
          disabled: !__props.element.content
        }, {
          reference: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, _toDisplayString(__props.element.content || '（无内容）'), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_scrollbar, {
              width: 200,
              "max-height": 60
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.element.content), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["disabled"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_checkbox, {
      class: "pages-item-selection",
      modelValue: __props.element.checked,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((__props.element.checked) = $event)),
      disabled: !__props.alwaysEnable && __props.element.status !== _unref(PDF_PAGE_STATUS).SUCCESS,
      size: "large",
      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (emits('checkboxClick', __props.element)), ["stop"]))
    }, null, 8, ["modelValue", "disabled"]),
    (__props.element.status === _unref(PDF_PAGE_STATUS).SUCCESS)
      ? (_openBlock(), _createBlock(_unref(VideoPlay), {
          key: 1,
          class: "single-page-setting-btn",
          onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (emits('imageClick', __props.element)), ["stop"]))
        }))
      : (__props.element.status === _unref(PDF_PAGE_STATUS).GENERATING)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "single-page-setting-text",
            onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createVNode(_unref(Loading), { class: "single-page-setting-text-icon" }),
            _cache[8] || (_cache[8] = _createElementVNode("span", null, "生成中", -1))
          ]))
        : (_openBlock(), _createBlock(_unref(EditPen), {
            key: 3,
            class: "single-page-setting-btn",
            onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (emits('imageClick', __props.element)), ["stop"]))
          }))
  ], 2)), [
    [_directive_loading, loadingVideoPost.value]
  ])
}
}

})